import { createContext, useState } from 'react';
import api from 'services/api';

export const AplicacaoContext = createContext();

export const AplicacaoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [aplicacao, setAplicacao] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getAplicacao = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: aplicacao?.filter,
        page: aplicacao?.page,
        size: aplicacao?.size,
        order: aplicacao?.order,
        ...payload,
      });
      setAplicacao((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <AplicacaoContext.Provider
      value={{
        getLoading,
        aplicacao,
        getAplicacao,
      }}
    >
      {children}
    </AplicacaoContext.Provider>
  );
};
